import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1967fdc3")

_pushScopeId("data-v-1967fdc3")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "th-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.unavailableDays)
      ? (_openBlock(), _createBlock("table", _hoisted_1, [
          _createVNode("thead", null, [
            _createVNode("tr", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.headers, (data, key) => {
                return (_openBlock(), _createBlock("th", { key: key }, [
                  _createVNode("div", _hoisted_2, [
                    _createTextVNode(_toDisplayString(data.header) + " ", 1),
                    (data.tooltip)
                      ? _withDirectives((_openBlock(), _createBlock("span", {
                          key: 0,
                          title: data.tooltip
                        }, " ℹ️ ", 8, ["title"])), [
                          [_directive_tooltip]
                        ])
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createVNode("tbody", null, [
            _createVNode("tr", null, [
              _createVNode("td", null, "💰 " + _toDisplayString(_ctx.unavailableDays.paid.accepted), 1),
              _createVNode("td", null, "💰 " + _toDisplayString(_ctx.unavailableDays.paid.planned), 1),
              _createVNode("td", null, "⚡ " + _toDisplayString(_ctx.unavailableDays.unpaid.accepted), 1),
              _createVNode("td", null, "⚡ " + _toDisplayString(_ctx.unavailableDays.unpaid.planned), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})